import React from "react";
import {
  Helpers,
  ReactMFE,
  CommonMFE,
  MFE_NAMES,
} from "@tpd-web-common-libs/nodejs-library";
import { Item } from "./ListItem.style";

type TListItemProps = {
  key: string;
  id: string;
  config: any;
  isEditMode: boolean;
  __host__: any;
  index: number;
};

export const ListItem = (props: TListItemProps) => {
  const { key, id, config, isEditMode, __host__, index } = props;

  const immagine = config["Immagine"];
  const titolo = config["Titolo Principale"];
  const testo = config["Testo Principale"];
  const autore = config["Autore"];
  const note = config["Note"];
  const link = config["Scopri_dettagli"];
  const link2 = config["Documentazione"];
  const disposizioneImmagine =
    config["Disposizione Immagine"] && config["Disposizione Immagine"].value;
  const disposizione =
    Helpers.RemoteHelper.getSelectedValue(disposizioneImmagine);

  return (
    <Item key={key} disposizione={disposizione}>
      <div className="tpd-image">
        <ReactMFE.Remote
          id={CommonMFE.generateID(id, "Immagine", index)}
          __deps__={React}
          __host__={__host__}
          __mfeName__={MFE_NAMES.tpdImage}
          isEditMode={isEditMode}
          {...immagine}
        />
      </div>
      <div className="tpd-side-text">
        {(titolo?.value.value || isEditMode) && (
          <h3 className="tpd-content-title">
            <div className="tpd-short-text-container">
              <ReactMFE.Remote
                id={CommonMFE.generateID(id, "Titolo", index)}
                __deps__={React}
                __host__={__host__}
                __mfeName__={MFE_NAMES.tpdShortText}
                isEditMode={isEditMode}
                {...titolo}
              />
            </div>
          </h3>
        )}
        {(testo?.value?.value || isEditMode) && (
          <h3 className="tpd-content-text">
            <div className="tpd-short-text-container">
              <ReactMFE.Remote
                id={CommonMFE.generateID(id, "Testo", index)}
                __deps__={React}
                __host__={__host__}
                __mfeName__={MFE_NAMES.tpdShortText}
                isEditMode={isEditMode}
                {...testo}
              />
            </div>
          </h3>
        )}
        <p className="tpd-author">
          <div className="tpd-short-text-container">
            <ReactMFE.Remote
              id={CommonMFE.generateID(id, "Autore", index)}
              __deps__={React}
              __host__={__host__}
              __mfeName__={MFE_NAMES.tpdShortText}
              isEditMode={isEditMode}
              {...autore}
            />
          </div>
        </p>
        <div className="tpd-content-description">
          <ReactMFE.Remote
            id={CommonMFE.generateID(id, "Note", index)}
            __deps__={React}
            __host__={__host__}
            __mfeName__={MFE_NAMES.richText}
            isEditMode={isEditMode}
            {...note}
          />
        </div>
        {(link2?.value?.linkElement?.destination?.value || isEditMode) &&
          <div className="tpd-link-container">
            <ReactMFE.Remote
              id={CommonMFE.generateID(id, "Note", index)}
              __deps__={React}
              __host__={__host__}
              isEditMode={isEditMode}
              __mfeName__={MFE_NAMES.tpdCta}
              {...link2}
            />
          </div>
        }
        {(link?.value.linkElement.destination.value || isEditMode) && (
          <div className="tpd-content-buttons">
            <ReactMFE.Remote
              id={CommonMFE.generateID(id, "Link", index)}
              __deps__={React}
              __host__={__host__}
              __mfeName__={MFE_NAMES.tpdCta}
              isEditMode={isEditMode}
              {...link}
            />
          </div>
        )}
      </div>
    </Item>
  );
};
